import {
  labelAdmin,
  labelArgomenta,
  labelArgsWithExample,
  labelEditor,
  labelEstendi,
  labelExtendedContents,
  labelNewQuiz,
  labelNewSummary,
  labelQuiz,
  labelRiassunto,
  labelSchematize,
  labelSchematizza,
  labelAnswerTypeArticolo,
  labelUser,
} from "_constants";

import pdfIcon from "assets/icons/icon_pdf.svg";
// eslint-disable-next-line
import docIcon from "assets/icons/icon_doc.svg";
// eslint-disable-next-line
import txtIcon from "assets/icons/icon_txt.svg";

import correctReportIcon from "assets/icons/icon_correct_report.svg";
import wrongReportIcon from "assets/icons/icon_wrong_report.svg";
import partiallyWrongReportIcon from "assets/icons/icon_partially_wrong_report.svg";
import icon_quiz from "assets/icons/icon_quiz.svg";
import icon_args_exp from "assets/icons/icon_args_exp.svg";
import icon_articolo from "assets/icons/icon_articolo.svg";
import icon_summary from "assets/icons/icon_summary.svg";
import icon_schematize from "assets/icons/icon_schematize.svg";
import icon_ext_contents from "assets/icons/icon_ext_contents.svg";
import icon_quiz_grey from "assets/icons/icon_quiz_grey.svg";
import icon_args_exp_grey from "assets/icons/icon_args_exp_grey.svg";
import icon_summary_grey from "assets/icons/icon_summary_grey.svg";
import icon_schematize_grey from "assets/icons/icon_schematize_grey.svg";
import icon_ext_contents_grey from "assets/icons/icon_ext_contents_grey.svg";
import icon_articolo_grey from "assets/icons/icon_articolo_grey.svg";
import {
  StateSourceDone,
  StateSourceEnqueued,
  StateSourceError,
} from "components/shared";

export const getRoleName = (role: number) => {
  switch (role) {
    case 0:
      return labelAdmin;
    case 1:
      return labelUser;
    case 2:
      return labelEditor;
    default:
      return labelUser;
  }
};

export const getAnswerType = (type: number) => {
  switch (type) {
    case 1:
      return { icon: icon_quiz, name: labelNewQuiz };
    case 2:
      return { icon: icon_summary, name: labelNewSummary };
    case 3:
      return { icon: icon_schematize, name: labelSchematize };
    case 4:
      return { icon: icon_ext_contents, name: labelExtendedContents };
    case 5:
      return { icon: icon_args_exp, name: labelArgsWithExample };
    case 6:
      return { icon: icon_articolo, name: labelAnswerTypeArticolo };
    default:
      return { icon: "", name: "" }; // Default a User
  }
};

export const getAnswerTypeGrey = (type: number) => {
  switch (type) {
    case 1:
      return { icon: icon_quiz_grey, name: labelNewQuiz };
    case 2:
      return { icon: icon_summary_grey, name: labelNewSummary };
    case 3:
      return { icon: icon_schematize_grey, name: labelSchematize };
    case 4:
      return { icon: icon_ext_contents_grey, name: labelExtendedContents };
    case 5:
      return { icon: icon_args_exp_grey, name: labelArgsWithExample };
    case 6:
      return { icon: icon_articolo_grey, name: labelAnswerTypeArticolo };
    default:
      return { icon: "", name: "" }; // Default a User
  }
};

export const formatDataSource = (data: string, withTime: boolean = false) => {
  if (!data) return "-";
  let formattedDate = new Intl.DateTimeFormat("it-IT", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: withTime ? "2-digit" : undefined,
    minute: withTime ? "2-digit" : undefined,
  }).format(new Date(data));

  if (withTime) {
    formattedDate = formattedDate.replace(",", " -");
  }
  return formattedDate;
};

export const getFileIconByFileType = (fileType?: string) => {
  if (fileType?.includes("/")) {
    fileType = fileType.split("/")[1];
  }

  switch (fileType) {
    case "pdf":
      return pdfIcon;
    case "docx":
      return docIcon;
    case "txt":
      return txtIcon;
    default:
      return txtIcon;
  }
};

export const getReportTypeIcon = (type: string) => {
  switch (type) {
    case "correct":
      return correctReportIcon;
    case "wrong":
      return wrongReportIcon;
    case "partially_wrong":
      return partiallyWrongReportIcon;
    default:
      return correctReportIcon;
  }
};
export const getTypeToneOfVoice = (idType: number) => {
  //da cambiare in 0.5 e 1 gli switch case
  switch (idType) {
    case 0:
      return "Formale";
    case 0.5:
      return "Bilanciata";
    case 1:
      return "Creativa";
    default:
      return "Formale";
  }
};

export const formatBytes = (bytes: number, decimals: number) => {
  if (!bytes) return "0 Bytes";
  let k = 1024,
    dm = decimals || 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const getSuggestionClassNameByIndex = (index: number) => {
  switch (index) {
    case 0:
      return labelQuiz;
    case 1:
      return labelRiassunto;
    case 2:
      return labelSchematizza;
    case 3:
      return labelEstendi;
    case 4:
      return labelArgomenta;
    case 5:
      return labelAnswerTypeArticolo.toLocaleLowerCase();
    default:
      return "";
  }
};

export const getNamePaddBySuggestionCardIndex = (index: number) => {
  switch (index) {
    case 1:
      return { className: "padd-left-83", name: labelNewQuiz };
    case 2:
      return { className: "padd-left-118", name: labelNewSummary };
    case 3:
      return { className: "padd-left-104", name: labelSchematize };
    case 4:
      return { className: "padd-left-142", name: labelExtendedContents };
    case 5:
      return { className: "padd-left-174", name: labelArgsWithExample };
    case 6:
      return { className: "padd-left-74", name: labelAnswerTypeArticolo };
    default:
      return { className: "", name: "" };
  }
};

export const downloadFile = (
  res: any,
  type: number = 0,
  fileName: string = ""
) => {
  const blob = new Blob([res.data], { type: res.headers["content-type"] });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;

  if (type) {
    fileName = `risposte_${new Date().toLocaleDateString()}`;
  }
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const getStateSourceElement = (
  state: "DONE" | "ERROR" | "ENQUEUED",
  onClickCallback?: Function
) => {
  switch (state) {
    case "DONE":
      return StateSourceDone();
    case "ERROR":
      return StateSourceError(onClickCallback!);
    default:
      return StateSourceEnqueued();
  }
};
